import React, { useState } from "react";
import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";
import { useNotify } from "react-admin";
import { envSettings } from "../../settings/env";

const useStyles = makeStyles((theme) => ({
	button: {
		marginLeft: theme.spacing(2),
	},
	dateField: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
		width: "100%",
	},
}));

export const ExportAnswersButton = ({ record }) => {
	const classes = useStyles();
	const notify = useNotify();
	const [open, setOpen] = useState(false);
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [loading, setLoading] = useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
		setStartDate("");
		setEndDate("");
	};

	const handleExport = async () => {
		try {
			setLoading(true);
			let url = `${envSettings.baseUrl}/surveys/export/${record.id}`;

			const params = new URLSearchParams();
			if (startDate) params.append("startDate", startDate);
			if (endDate) params.append("endDate", endDate);

			if (params.toString()) {
				url += `?${params.toString()}`;
			}

			const response = await fetch(url, {
				method: "GET",
				credentials: "include",
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error("Export failed:", errorText);
				throw new Error(`Export failed: ${response.status} ${response.statusText}`);
			}

			const blob = await response.blob();
			const downloadUrl = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = downloadUrl;

			const contentDisposition = response.headers.get("Content-Disposition");
			let filename = "SurveyAnswers.csv";
			if (contentDisposition) {
				let filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
				if (filenameMatch) {
					filename = decodeURIComponent(filenameMatch[1]);
				} else {
					filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
					if (filenameMatch) {
						filename = filenameMatch[1];
					}
				}
			}

			link.download = filename;
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(downloadUrl);

			notify("Export successful", "success");
			handleClose();
		} catch (error) {
			notify("Export failed: " + error.message, "error");
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Button
				variant="contained"
				color="primary"
				startIcon={<GetAppIcon />}
				onClick={handleOpen}
				className={classes.button}
			>
				Export Answers
			</Button>

			<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
				<DialogTitle>Export Survey Answers</DialogTitle>
				<DialogContent>
					<TextField
						label="Start Date"
						type="date"
						value={startDate}
						onChange={(e) => setStartDate(e.target.value)}
						className={classes.dateField}
						InputLabelProps={{
							shrink: true,
						}}
					/>
					<TextField
						label="End Date"
						type="date"
						value={endDate}
						onChange={(e) => setEndDate(e.target.value)}
						className={classes.dateField}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="default" disabled={loading}>
						Cancel
					</Button>
					<Button
						onClick={handleExport}
						color="primary"
						variant="contained"
						disabled={loading}
					>
						{loading ? "Exporting..." : "Export"}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
